export enum TelematicsRouteFilter {
  PLANNED = 'planned',
  UNPLANNED = 'unplanned',
}
